import { Injectable } from '@angular/core';
import { UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { OAuthServiceService } from '../services/o-auth-service.service';
import { Logger } from '../logging/logger.service';

const log = new Logger('AdminUserRouteGuardService');

@Injectable({ providedIn: 'root' })
export class AdminUserRouteGuardService  {

  isAuthenticated$!: Observable<boolean>;
  isAuthenticated: boolean = false;

  constructor(private oauthService: OAuthServiceService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    this.isAuthenticated$ = this.oauthService.isLoggedIn;
    this.isAuthenticated$.subscribe((data: boolean) => {
      log.debug('AdminUserRouteGuardService - canActivate ', data);
      this.isAuthenticated = data;
    });

    if (this.isAuthenticated) {
      return true;
    } else {
      log.debug('Not authenticated, redirecting and adding redirect url...');
      //this.router.navigate(['/login'], { queryParams: { redirect: state.url }, replaceUrl: true });
      this.oauthService.doLogin();
      return false;
    }
  }
}
